/**
 * @Author: Nenad Brcic
 * @Date: 28.05.16
 * @Email: neno@neno.ch
 */

import React, {Component, PropTypes} from 'react';
import CSSModules from 'react-css-modules';
import styles from './ContentTemplate.scss';

const ContentTemplate = ({ children }) => (
    <div>
        { children }
    </div>
);

ContentTemplate.propTypes = {
    children: PropTypes.object.isRequired,
};

export default CSSModules(ContentTemplate, styles);


// WEBPACK FOOTER //
// ./app/components/ContentTemplate/index.jsx